export default {
  title: "",
  subtitle: "",
  path: "person_show",
  paragraph: "To check a person’s information, you can use the following endpoint:",
  request: {
    method: "GET", 
    endpoint: "/subject/people/:id",
    responses: {
      "data": {
        "updated_at": "2021-03-08T22:32:04.515724",
        "status": "approved",
        "social_name": "Joaquin Teixeira dos Antos",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": "98989-8989",
        "net_monthly_average_income": "3000.00",
        "inserted_at": "2021-03-08T22:32:04.475951",
        "id": "ba70edd2-2210-40de-aa14-2e8efa1416f2",
        "fiscal_country": "Brasil",
        "email": "joaquin@gmail.com",
        "documents": [
          {
            "labels": [
              "person-photo"
            ],
            "id": "1c130b69-fb92-4420-aa68-f442703510d0",
            "file_url": "https://onedrive.com/files/document-z.pdf",
            "file_type": "application/pdf"
          }
        ],
        "document_type": "passport",
        "document_number": "5079865",
        "clearance_level": 1,
        "birth_date": "1991-01-01",
        "address_street": "Rua Barão do Rio Branco",
        "address_state": "MG",
        "address_postal_code": "33405938",
        "address_number": "670",
        "address_country": "BR",
        "address_complement": "Apt. 1802",
        "address_city": "Divinópolis"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonsListByID.js